import React from 'react'
import clsx from 'clsx'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import TimelineEmail, {
  TimelineEmailType
} from '@SonarCX/components/molecules/ChatModals/TaskModal/TaskComments/TimelineEmail'

import {
  selectExtensionAPI,
  loadEmailContent
} from '@SonarCX/slices/extensionAPI'
import useOtherStyles from '../Other/styles'
import useStyles from './styles'

type EmailProps = {
  email: Media
  isYours: boolean
}

const Email: React.FC<EmailProps> = ({ email, isYours }) => {
  const dispatch = useAppDispatch()

  const { loadedEmails } = useAppSelector(selectExtensionAPI)

  const hydratedEmail = React.useMemo(() => {
    const content = loadedEmails[email.id]

    if (!content) {
      return null
    }

    const hydrated: TimelineEmailType = {
      ...content,
      stamp: new Date(content.receivedTime),
      id: email.id
    }

    return hydrated
  }, [email, loadedEmails])

  const otherClasses = useOtherStyles({ isYours })
  const classes = useStyles({ isYours })

  // Load email content from media
  React.useEffect(() => {
    dispatch(loadEmailContent(email))
  }, [dispatch, email])

  if (!hydratedEmail) {
    return null
  }

  return (
    <div className={clsx(otherClasses.root, classes.root)}>
      <TimelineEmail
        email={hydratedEmail}
        className={classes.emailRoot}
        emailRootClass={classes.emailRootClass}
      />
    </div>
  )
}

export default Email
